import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail, Lock, User, Heart, Github } from 'lucide-react';
import { AnimatedGradient } from '../components/AnimatedGradient';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function RegisterPage() {
  return <div className="min-h-screen w-full relative flex items-center justify-center p-4" data-id="element-368">
      <AnimatedGradient data-id="element-369" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="w-full max-w-md" data-id="element-370">
        <div className="bg-[#FDF8F3]/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/50 p-8 md:p-10" data-id="element-371">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-372">
            <Link to="/" className="inline-flex items-center gap-3 mb-6 group" data-id="element-373">
              <img src="https://cdn.magicpatterns.com/uploads/6der9p7cTuhPYDgtJnKRAY/Group_1448.svg" alt="Danke Consulting" className="h-10 group-hover:scale-105 transition-transform duration-300" data-id="element-374" />
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-375">
              Crear una cuenta
            </h1>
            <p className="text-gray-600" data-id="element-376">
              Empieza a construir campañas hoy.
            </p>
          </div>

          {/* Form */}
          <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-377">
            <Input label="Nombre Completo" type="text" placeholder="Claudia Cruz" icon={<User className="w-4 h-4" data-id="element-379" />} data-id="element-378" />

            <Input label="Correo Electrónico" type="email" placeholder="ejemplo@dankeconsulting.com" icon={<Mail className="w-4 h-4" data-id="element-381" />} data-id="element-380" />

            <Input label="Contraseña" type="password" placeholder="Crea tu contraseña" icon={<Lock className="w-4 h-4" data-id="element-383" />} data-id="element-382" />

            <div className="flex items-start gap-2 mt-2" data-id="element-384">
              <input id="terms" type="checkbox" className="mt-1 w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500" data-id="element-385" />
              <label htmlFor="terms" className="text-xs text-gray-600 leading-relaxed" data-id="element-386">
                Acepto{' '}
                <a href="#" className="text-gray-900 hover:underline" data-id="element-387">
                  Términos del Servicio
                </a>{' '}
                y{' '}
                <a href="#" className="text-gray-900 hover:underline" data-id="element-388">
                  Política de Privacidad
                </a>
                .
              </label>
            </div>

            <Button className="w-full" size="lg" data-id="element-389">
              Crear cuenta
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-8" data-id="element-390">
            <div className="absolute inset-0 flex items-center" data-id="element-391">
              <div className="w-full border-t border-gray-200" data-id="element-392"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-393">
              <span className="px-2 bg-[#FDF8F3] text-gray-500" data-id="element-394">
                O registrate con
              </span>
            </div>
          </div>

          {/* Social Login */}
          <div className="grid grid-cols-1 gap-4" data-id="element-395">
            <Button variant="social" icon={<svg className="w-4 h-4" viewBox="0 0 24 24" data-id="element-397">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-398" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-399" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-400" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-401" />
                </svg>} data-id="element-396">
              Google
            </Button>
          </div>

          {/* Footer */}
          <p className="mt-8 text-center text-sm text-gray-600" data-id="element-402">
           ¿Ya tienes una cuenta? {' '}
            <Link to="/login" className="font-semibold text-gray-900 hover:underline" data-id="element-403">
              Inicia sesión
            </Link>
          </p>
        </div>
      </motion.div>
    </div>;
}